import actions from './actions';
import { createReducer } from '../../../../../../helpers/reducer';

// ------------------------------
// Initial State
// ------------------------------
const initState = {
  messages: null,
  loading: false,
  total: 0,
  filteredTotal: 0,
};

// ------------------------------
// Action Handlers
// ------------------------------
function onLoad(state) {
  return {
    ...state,
    loading: true,
  };
}

function onLoadSuccess(state, { payload }) {
  const { data, total, filteredTotal } = payload;

  return {
    ...state,
    messages: data,
    total,
    filteredTotal,
    loading: false,
  };
}

function onClearStore() {
  return { ...initState };
}

// ------------------------------
// Exported reducer function.
// ------------------------------
export default createReducer(initState, {
  [actions.LOAD]: onLoad,
  [actions.LOAD_SUCCESS]: onLoadSuccess,
  [actions.CLEAR_STORE]: onClearStore,
});
